"use strict";
// SVG setup
var draw = SVG('drawing').size(800, 600);
var areasLayer = draw.group();
var buildingsLayer = draw.group();
var highwaysLayer = draw.group();
var pointsLayer = draw.group();

// Map informations
var mapOrigin = {"lat": 50.472345, "lon": 4.819453}
var scale = 2.5;
var xOffset = -950;
var yOffset = 0;

const div = document.querySelector(".div--popup")
const textFixed = document.querySelector(".text-top")

// Points du jeux
const homepage = document.querySelector(".homepage")
const homepageText = document.querySelector(".text--homepage")
const map = document.querySelector(".map")
const mLoc = document.querySelector(".map--loc")
const firstDest = document.querySelector(".first--dest")
const questFirst = document.querySelector(".first--quest")
const submitDest = document.querySelector(".goto--quest")
const firstQuest = document.querySelector(".first--quest")
const form = document.querySelector(".form--search")
const searchInput = document.querySelector(".search__field")
const falseResponse = document.querySelector(".first--response__false")
const trueResponse = document.querySelector(".first--response__true")
const secondDestination = document.querySelector(".second--destination")
const homepageStart = document.querySelector(".homepage--start")

const secondDest = document.querySelector(".second--dest")
const submitSD = document.querySelector(".submit--second__dest")
const secondQuest = document.querySelector(".second--quest")
const formSecond = document.querySelector(".form--second")
const searchInputSecond = document.querySelector(".search__field__second")
const trueAgain = document.querySelector(".second--response__true")
const falseAgain = document.querySelector(".second--response__false")
const thirdDest = document.querySelector(".third--destination")

const thirdInfo = document.querySelector(".third--destinfo")
const submitThird = document.querySelector(".submit--third__dest")
const thirdQuest = document.querySelector(".third--quest")
const formThird = document.querySelector(".form--third")
const searchInputThird = document.querySelector(".search__field__third")
const trueThird = document.querySelector(".third--response__true")
const falseThird = document.querySelector(".third--response__false")
const nextDest = document.querySelector(".forth--destination")

const forthInfo = document.querySelector(".forth--destinfo")
const submitForth = document.querySelector(".submit--forth__dest")
const forthQuest = document.querySelector(".forth--quest")
const formForth = document.querySelector(".form--forth")
const searchInputForth = document.querySelector(".search__field__forth")
const trueForth = document.querySelector(".forth--response__true")
const falseForth = document.querySelector(".forth--response__false")
const finalDest = document.querySelector(".fifth--destination")

const fifthInfo = document.querySelector(".fifth--destinfo")
const submitFifth = document.querySelector(".submit--fifth__dest")
const fifthQuest = document.querySelector(".fifth--quest")
const formFifth = document.querySelector(".form--fifth")
const searchInputFifth = document.querySelector(".search__field__fifth")
const trueFifth = document.querySelector(".fifth--response__true")
const falseFifth = document.querySelector(".fifth--response__false")
const end = document.querySelector(".end")
const explain = document.querySelector(".explication")


const firstN = document.querySelector(".first--neutre")
const firstW = document.querySelector(".first--wrong")
const secondN = document.querySelector(".second--neutre")
const secondW = document.querySelector(".second--wrong")
const thirdN = document.querySelector(".third--neutre")
const thirdW = document.querySelector(".third--wrong")
const forthN = document.querySelector(".forth--neutre")
const forthW = document.querySelector(".forth--wrong")
const fifthN = document.querySelector(".fifth--neutre")
const fifthW = document.querySelector(".fifth--wrong")
const animation = document.querySelector(".testanim")

const logo = document.querySelector(".logo")
const animBigger = document.querySelector(".anim--bigger")
const container = document.querySelector(".container")
const happy = document.querySelector(".happy")
const happyS = document.querySelector(".happy--second")
const happyT = document.querySelector(".happy--third")
const happyF= document.querySelector(".happy--forth")
const happyFi = document.querySelector(".happy--fifth")
const boxClosed = document.querySelector(".box--closed")
const boxOpen = document.querySelector(".box--open")
const buttonPirate = document.querySelector(".pirate")
const pirateF = document.querySelector(".pirate--fuck")

fetch("../assets/js/namur.json")
.then(response => response.json())
.then((data) => {
    let nodecpt = 0;
    // Draw highways
    for(let way of data.highways){
        drawHighway(way);
        nodecpt = nodecpt + way.nodes.length;
    }
    console.log(data.highways.length+ " routes ("+nodecpt+" points)");

    // Draw areas
    nodecpt = 0;
    for(let area of data.areas){
        drawArea(area);
        nodecpt = nodecpt + area.nodes.length;

    }
    console.log(data.areas.length+ " zones ("+nodecpt+" points)");

    // Draw buildings
    nodecpt = 0;
    for(let building of data.buildings){
        drawBuilding(building);
        nodecpt = nodecpt + building.nodes.length;
    }
    console.log(data.buildings.length+ " batiments ("+nodecpt+" points)");


    //Caché la page de garde
    homepageStart.addEventListener("click", (e) => {

      logo.classList.add("anim--bigger")
      logo.addEventListener("animationend", (e) =>{
        document.body.classList.add('animation')
        map.classList.remove("hidden")
        map.classList.add("testanim")
        homepageText.classList.add("hidden")
        homepage.classList.add("hidden")
        homepage.classList.remove("cache--flex")
        explain.classList.remove("hidden")
        explain.classList.add("testanim")
        textFixed.classList.remove("hidden")
      })

    })

    //ajouter les points
    drawFirstImage();
    drawSecondImage();
    drawThirdImage();
    drawForthImage();
    drawFifthImage();
    const secondPoint = document.querySelector(".second--point")
    const thirdPoint = document.querySelector(".third--point")
    const forthPoint = document.querySelector(".forth--point")
    const fifthPoint = document.querySelector(".fifth--point")




    let image = document.querySelector("image");
    image.addEventListener("click", (e) => {
      firstDest.classList.remove("hidden")
      firstDest.classList.add("div--popup")
      firstDest.classList.add("div--center")
      firstDest.classList.add("testanim")
      explain.classList.add("hidden")
      textFixed.classList.add("hidden")

    });


    // voir la première question
    submitDest.addEventListener("click", (e) => {
      firstDest.classList.add("hidden")
      firstQuest.classList.remove("hidden")
      firstQuest.classList.add("testanim")
      container.classList.add("testanim")
      questFirst.classList.add("div--center")
      image.classList.add("hidden")
      firstDest.classList.remove("div--center")
    })


    // première question
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      const searchTerm = searchInput.value;
      if(searchTerm == "Jan Fabre" || searchTerm == "kedis" || searchTerm == "Jan Fabre " || searchTerm == "jan fabre " || searchTerm == "jan fabre"  ){
        firstQuest.classList.add("hidden")
        trueResponse.classList.remove("hidden")
        questFirst.classList.remove("div--center")
        trueResponse.classList.add("div--center")
      }else if(searchTerm == "cheat"){
        firstQuest.classList.add("hidden")
        firstQuest.classList.remove("div--center")
        trueFifth.classList.remove("hidden")
        trueFifth.classList.add("div--center")
      }else{
        falseResponse.classList.remove("hidden")
        firstN.classList.add("hidden")
        firstW.classList.remove("hidden")
      }
    })

    // afficher deuxième points
    secondDestination.addEventListener("click", (e) => {
      happy.classList.add("anim--bigger")
      happy.addEventListener("animationend", (e) =>{
        secondPoint.classList.remove("hidden")
        trueResponse.classList.add("hidden")
        trueResponse.classList.remove("div--center")
        explain.classList.remove("hidden")
        textFixed.classList.remove("hidden")
      })

    })


    //deuxième destination
    secondPoint.addEventListener("click", (e) => {
      secondDest.classList.remove("hidden")
      secondDest.classList.add("div--center")
      secondDest.classList.add("testanim")
      explain.classList.add("hidden")
      textFixed.classList.add("hidden")
    })

    submitSD.addEventListener("click", (e) => {
      secondQuest.classList.remove("hidden")
      secondQuest.classList.add("testanim")
      secondDest.classList.add("hidden")
      secondQuest.classList.add("div--center")
      secondDest.classList.remove("div--center")
    })

    //réponse deuxième question
    formSecond.addEventListener("submit", (e) => {
      e.preventDefault();
      const searchTerm = searchInputSecond.value;
      if(searchTerm == "Des chats" ||  searchTerm == "kedis" ||  searchTerm == "chat" ||  searchTerm == "chats" ||  searchTerm == "des chats"){
        secondQuest.classList.add("hidden")
        secondQuest.classList.remove("div--center")
        trueAgain.classList.remove("hidden")
        trueAgain.classList.add("div--center")
      }else{
        falseAgain.classList.remove("hidden")
        secondN.classList.add("hidden")
        secondW.classList.remove("hidden")
      }
    })




    thirdDest.addEventListener("click", (e) =>{
      happyS.classList.add("anim--bigger")
      happyS.addEventListener("animationend", (e) =>{
        thirdPoint.classList.remove("hidden")
        secondQuest.classList.add("hidden")
        trueAgain.classList.add("hidden")
        trueAgain.classList.remove("div--center")
        secondPoint.classList.add("hidden")
        explain.classList.remove("hidden")
        textFixed.classList.remove("hidden")
      })

    })

    thirdPoint.addEventListener("click", (e) => {
      thirdInfo.classList.remove("hidden")
      explain.classList.add("hidden")
      textFixed.classList.add("hidden")
      thirdInfo.classList.add("div--center")
      thirdInfo.classList.add("testanim")
    })

    submitThird.addEventListener("click", (e) => {
      thirdInfo.classList.add("hidden")
      thirdInfo.classList.remove("div--center")
      thirdQuest.classList.remove("hidden")
      thirdQuest.classList.add("div--center")
    })
    formThird.addEventListener("submit", (e) => {
      e.preventDefault();
      const searchTerm = searchInputThird.value;
      if(searchTerm == "Musée des Arts Décoratifs" ||  searchTerm == "kedis" ||  searchTerm == "Le musée des arts décoratif" ||  searchTerm == "Le Musée des Arts Décoratif" ||  searchTerm == "le musée des arts décoratif"){
        thirdQuest.classList.add("hidden")
        thirdQuest.classList.remove("div--center")
        trueThird.classList.remove("hidden")
        trueThird.classList.add("div--center")
      }else{
        falseThird.classList.remove("hidden")
        thirdN.classList.add("hidden")
        thirdW.classList.remove("hidden")
      }
    })



    nextDest.addEventListener("click", (e) =>{
      happyT.classList.add("anim--bigger")
      happyT.addEventListener("animationend", (e) =>{
        forthPoint.classList.remove("hidden")
        trueThird.classList.add("hidden")
        trueThird.classList.remove("div--center")
        thirdPoint.classList.add("hidden")
        explain.classList.remove("hidden")
        textFixed.classList.remove("hidden")
      })
    })

    forthPoint.addEventListener("click", (e) =>{
      forthInfo.classList.remove("hidden")
      forthInfo.classList.add("testanim")
      forthInfo.classList.add("div--center")
      explain.classList.add("hidden")
      textFixed.classList.add("hidden")
    })

    submitForth.addEventListener("click", (e) =>{
      forthInfo.classList.remove("div--center")
      forthInfo.classList.add("hidden")
      forthQuest.classList.remove("hidden")
      forthQuest.classList.add("testanim")
      forthQuest.classList.add("div--center")
      explain.classList.add("hidden")
      textFixed.classList.add("hidden")
    })

    formForth.addEventListener("submit", (e) => {
      e.preventDefault();
      const searchTerm = searchInputForth.value;
      if(searchTerm == "Ses frites" ||  searchTerm == "kedis" ||  searchTerm == "frite" ||  searchTerm == "frites" ||  searchTerm == "les frites" ||  searchTerm == "Les frites"){
        forthQuest.classList.add("hidden")
        forthQuest.classList.remove("div--center")
        trueForth.classList.remove("hidden")
        trueForth.classList.add("div--center")
      }else{
        falseForth.classList.remove("hidden")
        forthN.classList.add("hidden")
        forthW.classList.remove("hidden")
      }
    })

    finalDest.addEventListener("click", (e) =>{
      happyF.classList.add("anim--bigger")
      happyF.addEventListener("animationend", (e) =>{
        fifthPoint.classList.remove("hidden")
        trueForth.classList.add("hidden")
        forthPoint.classList.add("hidden")
        trueForth.classList.remove("div--center")
        explain.classList.remove("hidden")
        textFixed.classList.remove("hidden")
      })

    })



    fifthPoint.addEventListener("click", (e) =>{
      fifthInfo.classList.remove("hidden")
      fifthInfo.classList.add("testanim")
      fifthInfo.classList.add("div--center")
      explain.classList.add("hidden")
      textFixed.classList.add("hidden")
    })

    submitFifth.addEventListener("click", (e) =>{
      fifthInfo.classList.add("hidden")
      fifthInfo.classList.remove("div--center")
      fifthQuest.classList.remove("hidden")
      fifthQuest.classList.add("div--center")
      fifthQuest.classList.add("testanim")
    })

    formFifth.addEventListener("submit", (e) => {
      e.preventDefault();
      const searchTerm = searchInputFifth.value;
      if(searchTerm == "Cathédrale Saint-Aubain" ||  searchTerm == "kedis" ||  searchTerm == "Saint-Aubain" ||  searchTerm == "La cathédrale Saint-Aubain"){
        fifthQuest.classList.add("hidden")
        fifthQuest.classList.remove("div--center")
        trueFifth.classList.remove("hidden")
        trueFifth.classList.add("div--center")
      }else{
        falseFifth.classList.remove("hidden")
        fifthN.classList.add("hidden")
        fifthW.classList.remove("hidden")
      }
    })

    end.addEventListener("click", (e) =>{
      happyFi.classList.add("anim--bigger")
      happyFi.addEventListener("animationend", (e) =>{
        fifthPoint.classList.add("hidden")
        map.classList.add("hidden")
        trueFifth.classList.add("hidden")
        trueFifth.classList.remove("div--center")
        boxClosed.classList.remove("hidden")
        boxClosed.classList.add("div--center")
      })

      boxClosed.addEventListener('click', (e) =>{
        boxClosed.classList.add('anime--rotate');
        boxClosed.addEventListener('animationend', function(){
          boxOpen.classList.remove("hidden")
          boxClosed.classList.add("hidden")
          boxClosed.classList.remove("div--center")
          boxOpen.classList.add("div--center")
          buttonPirate.classList.add("anime--delay")
        });
      });

      buttonPirate.addEventListener("click", (e) =>{
        boxOpen.classList.remove("div--center")
        boxOpen.classList.add("hidden")
        pirateF.classList.remove("hidden")
        pirateF.classList.add("div--center")
      })





    })




});



// Tortue Jan Fabre
function drawFirstImage(){
  let converter = new UtmConverter();
  let rootutmResult = converter.toUtm({coord: [mapOrigin.lon, mapOrigin.lat]});
  let startutmResult = converter.toUtm({coord: [4.866803,50.461040]});
  let ax = (startutmResult.coord.x - rootutmResult.coord.x) / scale;
  ax += xOffset;
  let ay = (rootutmResult.coord.y - startutmResult.coord.y) / scale;
  ay += yOffset;
  console.log(ax, ay)
  var image = draw.image('../assets/images/pointeur.svg')
  image.size(60, 60).move(ax, ay)
  image.addClass('hello')
}

//Miss Miaouw
function drawSecondImage(){
  let converter = new UtmConverter();
  let rootutmResult = converter.toUtm({coord: [mapOrigin.lon, mapOrigin.lat]});
  let startutmResult = converter.toUtm({coord: [4.867462,50.462351]});
  let ax = (startutmResult.coord.x - rootutmResult.coord.x) / scale;
  ax += xOffset;
  let ay = (rootutmResult.coord.y - startutmResult.coord.y) / scale;
  ay += yOffset;
  console.log(ax, ay)
  var image = draw.image('../assets/images/pointeur.svg')
  image.size(60, 60).move(ax, ay)
  image.addClass('second--point hidden')
}

// Musée des Arts Décoratifs
function drawThirdImage(){
  let converter = new UtmConverter();
  let rootutmResult = converter.toUtm({coord: [mapOrigin.lon, mapOrigin.lat]});
  let startutmResult = converter.toUtm({coord: [4.861181,50.463262]});
  let ax = (startutmResult.coord.x - rootutmResult.coord.x) / scale;
  ax += xOffset;
  let ay = (rootutmResult.coord.y - startutmResult.coord.y) / scale;
  ay += yOffset;
  console.log(ax, ay)
  var image = draw.image('../assets/images/pointeur.svg')
  image.size(60, 60).move(ax, ay)
  image.addClass('third--point hidden')
}


// Chez Gaby
function drawForthImage(){
  let converter = new UtmConverter();
  let rootutmResult = converter.toUtm({coord: [mapOrigin.lon, mapOrigin.lat]});
  let startutmResult = converter.toUtm({coord: [4.866920,50.468599]});
  let ax = (startutmResult.coord.x - rootutmResult.coord.x) / scale;
  ax += xOffset;
  let ay = (rootutmResult.coord.y - startutmResult.coord.y) / scale;
  ay += yOffset;
  console.log(ax, ay)
  var image = draw.image('../assets/images/pointeur.svg')
  image.size(60, 60).move(ax, ay)
  image.addClass('forth--point hidden')
}

// Brasserie François
function drawFifthImage(){
  let converter = new UtmConverter();
  let rootutmResult = converter.toUtm({coord: [mapOrigin.lon, mapOrigin.lat]});
  let startutmResult = converter.toUtm({coord: [4.860448,50.463860]});
  let ax = (startutmResult.coord.x - rootutmResult.coord.x) / scale;
  ax += xOffset;
  let ay = (rootutmResult.coord.y - startutmResult.coord.y) / scale;
  ay += yOffset;
  console.log(ax, ay)
  var image = draw.image('../assets/images/pointeur.svg')
  image.size(60, 60).move(ax, ay)
  image.addClass('fifth--point hidden')
}




function drawHighway(way){
    let points = [];
    for(let i = 0; i < way.nodes.length; i++){
        let converter = new UtmConverter();
        let rootutmResult = converter.toUtm({coord: [mapOrigin.lon, mapOrigin.lat]});
        let startutmResult = converter.toUtm({coord: [way.nodes[i].lon, way.nodes[i].lat]});
        let ax = (startutmResult.coord.x - rootutmResult.coord.x) / scale;
        ax += xOffset;
        let ay = (rootutmResult.coord.y - startutmResult.coord.y) / scale;
        ay += yOffset;
        points.push([ax, ay]);
    }
    let polyline = highwaysLayer.polyline(points);
    polyline.attr("class", "highway highway__"+way.category+" "+"highway__"+way.category+"--"+way.subcategory);
}

function drawArea(shape){
  drawShape(shape, "area", areasLayer);
}

function drawBuilding(shape){
  drawShape(shape, "building", buildingsLayer);
}

function drawShape(shape, baseclass, layer){
    let points = [];
    let converter = new UtmConverter();
    for(let i = 0; i < shape.nodes.length; i++){
        let rootutmResult = converter.toUtm({coord: [mapOrigin.lon, mapOrigin.lat]});
        let startutmResult = converter.toUtm({coord: [shape.nodes[i].lon, shape.nodes[i].lat]});
        let ax = (startutmResult.coord.x - rootutmResult.coord.x) / scale;
        ax += xOffset;
        let ay = (rootutmResult.coord.y - startutmResult.coord.y) / scale;
        ay += yOffset;
        points.push([ax, ay]);
    }
    let polyline = layer.polygon(points);
    polyline.attr("class", baseclass+" "+baseclass+"__"+shape.category+" "+baseclass+"__"+shape.category+"--"+shape.subcategory);
}
